
<script lang="ts">
  import { getContext } from "svelte";
  import { VisioMapApp } from "./vg/visiomap";
  import { fly } from "svelte/transition";
  import { type Readable } from "svelte/store";
  import { type UI } from "./UI.svelte";

  const app = getContext<VisioMapApp>('app');
  const { fullscreen, state, current_floor } = app;

  const layout = getContext<Readable<UI>>('ui_layout')

</script>

<div class="vc" class:fullscreen={$fullscreen}>
  <div class="main">
    <slot />
    {#if $state == 'embedded_view' && $current_floor}
      <div class="floor-label">{$current_floor.name}</div>
    {:else}
      <div class="top" transition:fly={{ duration: 200, y: -64, opacity: 0.5 }}>
        {#if $layout.main.top}
          <slot name="top" />
        {/if}
        <slot name="close" />
      </div>
    {/if}
    {#if $layout.main.floor}
      <div class="floor" transition:fly={{ duration: 200, y: 64, opacity: 0.5 }}>
        <slot name="floor" />
      </div>
    {/if}
  </div>
  {#if $layout.main.aside}
    <div class="aside" transition:fly={{ duration: 200, x: '-100%', opacity: 0.5 }}>
      <slot name="side" />
    </div>
  {/if}
  {#if $layout.main.bottom}
    <div class="bottom" transition:fly={{ duration: 200, x: '100%', opacity: 0.5 }}>
      <slot name="bottom" />
    </div>
  {/if}
</div>

<style lang="scss">
  .vc {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: var(--_bg-1st);
    overflow: hidden;
  }

  :global(::view-transition-old(map-view-control)),
  :global(::view-transition-new(map-view-control)) {
    animation-duration: 10s;
    height: 100%;
    width: 100%;
  }

  .vc > * {
    height: 100%;
  }

  .main {
    position: relative;
    overflow: hidden;
  }

  .main > :global(*:first-child) {
    height: 100%;
  }

  .floor-label {
    position: absolute;
    top: 0;
    padding: var(--_p1) var(--_p2);
    background-color: var(--_btn-pri-bg);
    color: var(--_btn-pri-c);
    font-weight: 600;
  }

  .top {
    display: flex;
    position: absolute;
    box-sizing: border-box;
    width: calc(100% - var(--_p3));
    top: 0;
    gap: var(--_p2);
    /* transform: translateY(calc(-100% - var(--_p2))); */
    margin: var(--_p1) var(--_p1) 0 var(--_p2);
    justify-content: end;
    align-items: center;

    /* opacity: 0; */
    pointer-events: none;

    & > :global(*) {
      pointer-events: all;
    }
    /* transition: all 200ms; */
  }

  .floor {
    position: absolute;
    right: var(--_p1);
    bottom: var(--_p1);
    /* transform: translateY(calc(100% + var(--_p2)));
    opacity: 0;
    transition: all 200ms; */
  }

  .aside {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    /* pointer-events: none; */
    z-index: 10;
  }

  .fullscreen {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    z-index: 10000; /* Beat all those 9999 boys */

    /* .top {
      transform: translateY(0);
      opacity: 1;
    } */
    /* .floor {
      transform: translateY(0);
      opacity: 1;
    } */
  }

  .bottom {
    position: absolute;
    width: 100%;
    height: auto;
    bottom: 0;
    box-shadow: var(--vgwv-shadow-up);
  }

  @media (min-width: 768px) {

    .aside {
      width: clamp(270px, 30%, 400px);
      height: 100%;
      order: 0;
      position: relative;
      box-shadow: var(--vgwv-shadow-down);
    }

    .fullscreen {
      display: flex;
      flex-direction: row;

      .main {
        flex-grow: 1;
        order: 1;
      }
    }
  }

</style>